import {
  DISPOSITIF_A_FABRIQUER,
  DISPOSITIF_EN_COURS_FABRICATION,
  DISPOSITIF_FABRICATION_TERMINEE,
  PAO_BACHE_COMMANDEES,
  PAO_MAQUETTES_VALIDES,
  IMPRESSIONS_TERMINEES,
  DISPOSITIF_EXPEDIE,
  DISPOSTIF_A_FACTURER,
  DISPOSITIF_A_POSER,
} from '@/configuration/logistique/suiviProduction/suiviProductionConfig';
import { ETAT_VALIDE, ETAT_TRAITE, ETAT_NOUVEAU } from '@/configuration/logistique/intervention/interventionConf';
import validationIntervention from '@/services/logistique/intervention/validationIntervention';
import validationDemandeImpression from '@/services/logistique/demandeImpression/validationDemandeImpression';
import { updateEtatAsync as DemandeUpdateEtatAsync } from '@/api/logistique/demandeLogistique/index';
import validationOT from '@/services/logistique/ordreTravail/tech/validation/validation';
import { createOTs } from '@/api/logistique/demandeImpression/index';
import store from '@/store/store';
import { updateEtatAsync as OtUpdateEtatAsync, get as getOTtech, deleteOt } from '@/api/logistique/ordreTravailTech';
import {
  ETAT_REALISE,
  ETAT_EN_COURS,
  ETAT_A_EXPEDIER,
  ETAT_EXPEDIE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import { mapDemandeLogistiqueToDemandeSuiviProduction } from '@/services/logistique/suiviProduction/mappingForDemandeSuiviProduction';
import { cloneDeep } from 'lodash';
import { ETAT_RECEPTIONNE, ETAT_PRISE_EN_CHARGE } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import mapOTtoDemandeSuiviProductionOT from '@/services/logistique/suiviProduction/mappingForOTSuiviProduction';
import validationGeneral from '@/services/validation/validation';
import translateOTtech from '@/services/logistique/ordreTravail/tech/validation/translate';
import VALIDATIONS from '@/services/logistique/suiviProduction/validationColumnSuiviProduction';
import i18n from '@/i18n';

function gestionSuiviProdValidationGénéral(response, messages, translate) {
  const champsVide = [];
  const messagesChampsVide = [];
  const retourMessages = cloneDeep(messages);
  validationGeneral(i18n, response, champsVide,
    messages, messagesChampsVide, translate);
  retourMessages.push(messagesChampsVide.map(m => {
    return { message: m };
  }));
  retourMessages.push(champsVide.map(cv => {
    return { message: cv, libelle: cv };
  }));
  return retourMessages.flat(2);
}

export async function UpdateEtatDemandeSuiviProduction(demande, etatSouhaite, etatOtSouhaite) {
  if (!demande || !etatSouhaite) return null;

  const data = {
    demandeIds: [demande.id],
    etat: etatSouhaite,
    actionUpdateEtat: true,
    etatOtCreation: etatOtSouhaite,
  };
  const [newDemande] = (await DemandeUpdateEtatAsync(data)).data.result;
  const typesOT = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeOt);
  return mapDemandeLogistiqueToDemandeSuiviProduction(newDemande, typesOT);
}

async function UpdateEtatOtAndDemandeSuiviProduction(demande, etatOtSouhaite, etatDemande) {
  if (!demande || !etatOtSouhaite) return demande;

  const messages = [];

  try {
    const payload = {
      otsIds: [demande.ot.id],
      etatSouhaite: etatOtSouhaite,
      realiserActionIntervention: true,
      impactEtatDemandes: true,
      isAnnulatonSuppression: false,
      dateOt: formatDate(new Date()),
    };
    await OtUpdateEtatAsync(payload);
    const newDemande = cloneDeep(demande);
    newDemande.etat = etatDemande;
    newDemande.ot.otEtat = etatOtSouhaite;
    return newDemande;
  } catch (e) {
    if (e.response?.data?.error) {
      validationIntervention(e.response, messages);
    }
    throw messages;
  }
}

function errorMouvementImpossible() {
  const messages = [
    { message: 'suiviProduction.error.mouvementImpossible' },
  ];
  throw messages;
}

async function actionCommandeATraiter(mouvement) {
  const messages = [];
  switch (mouvement.from) {
    case DISPOSITIF_A_FABRIQUER:
      return null;
    case DISPOSITIF_EN_COURS_FABRICATION:
      if (!VALIDATIONS[DISPOSITIF_EN_COURS_FABRICATION](mouvement.item)) {
        errorMouvementImpossible();
      }
      try {
        await deleteOt(mouvement.item.otTechniqueId, false);
        const data = {
          demandeIds: [mouvement.item.id],
          etat: ETAT_NOUVEAU,
          actionUpdateEtat: true,
        };
        const [newDemande] = (await DemandeUpdateEtatAsync(data)).data.result;
        await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.typeOt]);
        const typesOT = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeOt);
        return mapDemandeLogistiqueToDemandeSuiviProduction(newDemande, typesOT);
      } catch (e) {
        if (e.response?.data?.error) {
          validationIntervention(e.response, messages);
          validationOT(e.response, messages);
        }
        throw messages;
      }
    default:
      errorMouvementImpossible();
      return null;
  }
}

async function actionDispositifEnCoursFabrication(mouvement) {
  const messages = [];
  switch (mouvement.from) {
    case DISPOSITIF_EN_COURS_FABRICATION:
      return null;
    case DISPOSITIF_A_FABRIQUER:
      if (!VALIDATIONS[DISPOSITIF_A_FABRIQUER](mouvement.item)) {
        errorMouvementImpossible();
      }
      try {
        const data = {
          demandeIds: [mouvement.item.id],
          etat: ETAT_VALIDE,
          actionUpdateEtat: true,
        };
        const [newDemande] = (await DemandeUpdateEtatAsync(data)).data.result;
        await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.typeOt]);
        const typesOT = store.getters['parametres/parametre'](PARAMETRES_KEYS.typeOt);
        return mapDemandeLogistiqueToDemandeSuiviProduction(newDemande, typesOT);
      } catch (e) {
        if (e.response?.data?.error) {
          validationIntervention(e.response, messages);
        }
        throw messages;
      }
    case DISPOSITIF_FABRICATION_TERMINEE:
      if (!VALIDATIONS[DISPOSITIF_FABRICATION_TERMINEE](mouvement.item)) {
        errorMouvementImpossible();
      }
      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_EN_COURS, ETAT_RECEPTIONNE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

function actionDispositifFabricationTerminee(mouvement) {
  switch (mouvement.from) {
    case DISPOSITIF_FABRICATION_TERMINEE:
      return null;
    case DISPOSITIF_EN_COURS_FABRICATION:
      if (!VALIDATIONS[DISPOSITIF_EN_COURS_FABRICATION](mouvement.item)) {
        errorMouvementImpossible();
      }
      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_REALISE, ETAT_TRAITE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

async function actionPaoBacheCommandees(mouvement) {
  const messages = [];
  switch (mouvement.from) {
    case PAO_BACHE_COMMANDEES:
      return null;
    case PAO_MAQUETTES_VALIDES:
      if (!VALIDATIONS[PAO_MAQUETTES_VALIDES](mouvement.item)) {
        errorMouvementImpossible();
      }
      try {
        await deleteOt(mouvement.item.otTechniqueId, false);
        const newDemande = cloneDeep(mouvement.item);
        newDemande.otTechniqueId = null;
        newDemande.ot = null;
        return newDemande;
      } catch (e) {
        if (e.response?.data?.error) {
          validationOT(e.response, messages);
        }
        throw messages;
      }
    default:
      errorMouvementImpossible();
      return null;
  }
}

async function actionPaoMaquettesValidees(mouvement) {
  let messages = [];

  switch (mouvement.from) {
    case PAO_MAQUETTES_VALIDES:
      return null;
    case PAO_BACHE_COMMANDEES:
      if (!VALIDATIONS[PAO_BACHE_COMMANDEES](mouvement.item)) {
        errorMouvementImpossible();
      }
      try {
        const [otId] = (await createOTs([mouvement.item.id])).data.result;
        const ot = (await getOTtech(otId)).data.result;
        const newDemande = cloneDeep(mouvement.item);
        newDemande.otTechniqueId = ot.id;
        newDemande.ot = mapOTtoDemandeSuiviProductionOT(ot);
        return newDemande;
      } catch (e) {
        if (e.response?.data?.error) {
          validationDemandeImpression(e.response, messages);
          messages = gestionSuiviProdValidationGénéral(e.response, messages, translateOTtech);
        }
        throw messages;
      }
    case IMPRESSIONS_TERMINEES:
      if (!VALIDATIONS[IMPRESSIONS_TERMINEES](mouvement.item)) {
        errorMouvementImpossible();
      }
      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_EN_COURS, ETAT_RECEPTIONNE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

function actionImpressionTerminees(mouvement) {
  switch (mouvement.from) {
    case IMPRESSIONS_TERMINEES:
      return null;
    case PAO_MAQUETTES_VALIDES:
      if (!VALIDATIONS[PAO_MAQUETTES_VALIDES](mouvement.item)) {
        errorMouvementImpossible();
      }

      return UpdateEtatOtAndDemandeSuiviProduction(
        mouvement.item,
        ETAT_REALISE,
        ETAT_PRISE_EN_CHARGE,
      );
    default:
      errorMouvementImpossible();
      return null;
  }
}

function actionDispositifAPoser(mouvement) {
  switch (mouvement.from) {
    case DISPOSITIF_A_POSER:
      return null;
    case DISPOSITIF_EXPEDIE:
      if (!VALIDATIONS[DISPOSITIF_EXPEDIE](mouvement.item)) {
        errorMouvementImpossible();
      }

      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_A_EXPEDIER, ETAT_VALIDE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

function actionDispositifExpedie(mouvement) {
  switch (mouvement.from) {
    case DISPOSITIF_EXPEDIE:
      return null;
    case DISPOSITIF_A_POSER:
      if (!VALIDATIONS[DISPOSITIF_A_POSER](mouvement.item)) {
        errorMouvementImpossible();
      }
      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_EXPEDIE, ETAT_VALIDE);
    case DISPOSTIF_A_FACTURER:
      if (!VALIDATIONS[DISPOSTIF_A_FACTURER](mouvement.item)) {
        errorMouvementImpossible();
      }

      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_EXPEDIE, ETAT_VALIDE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

function actionDispositifAFacturer(mouvement) {
  switch (mouvement.from) {
    case DISPOSTIF_A_FACTURER:
      return null;
    case DISPOSITIF_EXPEDIE:
      if (!VALIDATIONS[DISPOSITIF_EXPEDIE](mouvement.item)) {
        errorMouvementImpossible();
      }

      return UpdateEtatOtAndDemandeSuiviProduction(mouvement.item, ETAT_REALISE, ETAT_TRAITE);
    default:
      errorMouvementImpossible();
      return null;
  }
}

export default async function actionSuiviProduction(mouvement) {
  let newItem;
  switch (mouvement.to) {
    case DISPOSITIF_A_FABRIQUER:
      newItem = (await actionCommandeATraiter(mouvement));
      break;
    case DISPOSITIF_EN_COURS_FABRICATION:
      newItem = (await actionDispositifEnCoursFabrication(mouvement));
      break;
    case DISPOSITIF_FABRICATION_TERMINEE:
      newItem = (await actionDispositifFabricationTerminee(mouvement));
      break;
    case PAO_BACHE_COMMANDEES:
      newItem = (await actionPaoBacheCommandees(mouvement));
      break;
    case PAO_MAQUETTES_VALIDES:
      newItem = (await actionPaoMaquettesValidees(mouvement));
      break;
    case IMPRESSIONS_TERMINEES:
      newItem = (await actionImpressionTerminees(mouvement));
      break;
    case DISPOSITIF_A_POSER:
      newItem = (await actionDispositifAPoser(mouvement));
      break;
    case DISPOSITIF_EXPEDIE:
      newItem = (await actionDispositifExpedie(mouvement));
      break;
    case DISPOSTIF_A_FACTURER:
      newItem = (await actionDispositifAFacturer(mouvement));
      break;
    default:
      errorMouvementImpossible();
      break;
  }
  if (!!newItem && !VALIDATIONS[mouvement.to](newItem)) {
    const message = [
      { message: 'suiviProduction.error.wrongNewItem' },
    ];
    throw message;
  }
  return newItem;
}
